<template>
  <a-modal
    title="查看订单"
    :maskClosable="false"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <!-- :cancelText="'取消'"
    @ok="handleCancel" -->
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取消 </a-button>
    </template>
    <!-- <div class="content"> -->
    <a-row :gutter="22">
      <a-form layout="vertical" :form="form">
        <a-col :span="12">
          <!-- 订单编号 -->
          <a-form-item
            label="订单编号"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div>
              <span type="text">{{ finOrderItem.orderNo }}</span>
              <span v-if="finOrderItem.isCrossSchool == 1" class="cross">
                <img src="/crossSchool.png" style="width: 16px" alt="" />
                <em>跨校订单</em>
              </span>
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 支付单号 -->
          <a-form-item
            label="支付单号"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div>
              <span type="text">{{ finOrderItem.transId }}</span>
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 订单类型 -->
          <a-form-item
            label="订单类型"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">{{ finOrderItem.orderTypeText }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 班级学校 -->
          <a-form-item
            label="班级学校"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">{{ finOrderItem.classSchool }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 订单标题 -->
          <a-form-item
            label="订单标题"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">{{ finOrderItem.orderTitle }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 订单状态 -->
          <a-form-item
            label="订单状态"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">{{ finOrderItem.statusText }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            label="支付类型"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">
              {{
                finOrderItem.paymentMode == 0
                  ? '预付费'
                  : finOrderItem.paymentMode == 1
                  ? '后付费'
                  : ''
              }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 价格 -->
          <a-form-item
            label="价格/元"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">{{ finOrderItem.totalPrice / 100 }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 购买人姓名 -->
          <a-form-item
            label="购买人姓名"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">{{ finOrderItem.buyerName }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 学员学校 -->
          <a-form-item
            label="学员学校"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">{{ finOrderItem.studentSchool }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 动态显示    -------------课程方名称 -->
          <a-form-item
            label="课程方"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
            v-if="finOrderItem.institutionType"
          >
            <div type="text">
              {{
                finOrderItem.institutionName
                  ? finOrderItem.institutionName
                  : '- -'
              }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item
            v-if="finOrderItem.institutionType"
            label="课程方种类"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">
              {{
                finOrderItem.institutionTypeName
                  ? finOrderItem.institutionTypeName
                  : '- -'
              }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 动态显示 -------------------- 课程名称 -->
          <a-form-item
            label="课程名称"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">
              {{ finOrderItem.className ? finOrderItem.className : '- -' }}
            </div>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 创建时间 -->
          <a-form-item
            label="创建时间"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
            <div type="text">{{ finOrderItem.gmtCreate }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="支付信息"
            :labelCol="{ lg: { span: 6 } }"
            :wrapperCol="{ lg: { span: 18 } }"
          >
          </a-form-item>
        </a-col>
      </a-form>
    </a-row>
    <a-table
      style="width: 100%"
      :columns="columns"
      :data-source="tableData"
      :pagination="false"
    >
    </a-table>
    <!-- </div> -->
  </a-modal>
</template>

<script>
export default {
  name: 'finOrderFormModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      classroomId: '',
      updateData: {},
      finOrderItem: {}, //展示订单详情的容器
      columns: [
        {
          title: '收付对象',
          width: 70,
          dataIndex: '收付对象', // attendDate
        },
        {
          title: '收付类型',
          width: 70,
          dataIndex: '收付类型', // attendDate
        },
        {
          title: '支付单号',
          dataIndex: '支付单号', // attendDate
        },
        {
          title: '金额',
          width: 50,
          dataIndex: '金额', // attendDate
        },
        {
          title: '状态',
          width: 70,
          dataIndex: '状态', // attendDate
        },
        {
          title: '完成时间',
          dataIndex: 'CompleteTime', // attendDate
        },
        {
          title: '关联信息',
          dataIndex: '关联信息', // attendDate
        },
      ],
      tableData: [],
    }
  },
  methods: {
    //初始化，显示
    init(type, params) {
      this.visible = true
      this.isAdd = type === 'add' ? true : false
      //初始化form表单数据
      if (params) {
        this.updateData = params
        this.finOrderItem = params
        this.tableData = params.payments
        console.log('this.finOrderItem', this.finOrderItem)
      } else {
        this.form.resetFields()
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, value) => {
        //校验通过
        if (!err) {
          if (this.isAdd) {
            this.addClassroom(value)
          } else {
            this.updateClassroom(value)
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.ant-form-item {
  margin-bottom: 5px;
}
.cross {
  margin-left: 5px;
  color: #d71616 !important;
  em {
    border: 1.5px solid #d71616;
    border-radius: 4px;
    margin-left: 2px;
    font-style: normal;
  }
}
.content {
  height: calc(100vh - 280px);
  overflow-y: auto;
}
</style>
